import { render, staticRenderFns } from "./BaseTagInput.vue?vue&type=template&id=0c191348&scoped=true&"
import script from "./BaseTagInput.vue?vue&type=script&lang=js&"
export * from "./BaseTagInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseTagInput.vue?vue&type=style&index=0&id=0c191348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c191348",
  null
  
)

export default component.exports